import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./CTASection.css";

export default function CTASection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="cta-section" ref={sectionRef}>
      <div className="cta-bg">
        <div className="cta-pattern"></div>
        <div className="cta-gradient"></div>
      </div>
      
      <div className={`cta-container ${isVisible ? "visible" : ""}`}>
        <div className="cta-content">
          <span className="cta-label">START YOUR PROJECT</span>
          <h2 className="cta-title">
            READY TO TRANSFORM
            <br />
            <span className="gold-text">YOUR PROPERTY?</span>
          </h2>
          <p className="cta-description">
            Get a free, no-obligation estimate from Central Jersey's most trusted 
            masonry experts. Call us directly or fill out our form—we'll get back 
            to you within 24 hours.
          </p>
          
          <div className="cta-buttons">
            <Link to="/estimate" className="btn-primary">
              GET FREE ESTIMATE
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
            <a href="tel:7322050086" className="btn-outline">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              (732) 205-0086
            </a>
          </div>
        </div>

        <div className="cta-features">
          <div className="cta-feature">
            <div className="feature-check">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <span>Free On-Site Estimate</span>
          </div>
          <div className="cta-feature">
            <div className="feature-check">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <span>No Obligation</span>
          </div>
          <div className="cta-feature">
            <div className="feature-check">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <span>Licensed & Insured</span>
          </div>
        </div>
      </div>
    </section>
  );
}
